import { AccordionRoot } from "@/components/atoms/Accordions/Accordion/ClientAccordion";
import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { AccordionStoryblok } from "@/types/blok-types";
import { SbBlokData, storyblokEditable } from "@storyblok/js";
import clsx from "clsx";
import styles from "./index.module.css";

interface Props {
  blok: AccordionStoryblok;
  preview?: boolean;
}

const alignments = {
  left: styles.left,
  center: styles.center,
  right: styles.right,
  full: styles.full
};

export const AccordionBlok = ({ blok, preview }: Props) => {
  return (
    <div
      data-layout="blok"
      {...storyblokEditable(blok as unknown as SbBlokData)}
    >
      <div
        className={clsx(
          styles.accordionRoot,
          blok.align && alignments[blok.align]
        )}
      >
        {blok.title && <h3 className={styles.title}>{blok.title}</h3>}
        <AccordionRoot>
          {blok.items.map((item, i) => (
            <StoryblokComponent
              preview={preview}
              blok={item}
              key={blok._uid}
              index={i}
            />
          ))}
        </AccordionRoot>
      </div>
    </div>
  );
};
